module.exports = __webpack_public_path__ + "static/img/logo15.92b2e25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo15.png
// module id = UXxb
// module chunks = 1